export default "__VITE_ASSET__v0OfrbRP__"